export default function () {
    return {
        GROUP_DEADLINE: '{GROUP_DEADLINE}'
    };
}



// WEBPACK FOOTER //
// ./src/app/enums/survey/introduction/placeholder/index.js